import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { LoaderIcon } from '@shared/assets/icons';
import { FC } from 'react';

interface SendingStatusProps {
  status?: string;
}

export const SendingStatus: FC<SendingStatusProps> = ({ status = 'Идёт отправка билетов' }) => {
  return (
    <div {...stylex.props(styles.info)}>
      <div {...stylex.props(styles.spinner)}>
        <LoaderIcon />
      </div>
      <div {...stylex.props(styles.status)}>{status}</div>
    </div>
  );
};
